<template>
  <div id="pageHeader">
    <div id="title">
      <h1>心乡农管理中心</h1>
    </div>
    <div id="version">
      <p>版本号1.0.1-2020.7</p>
    </div>
    <div id="line"></div>
    <div id="location">
      <p class="third">{{HeaderLocationOne.name}}</p>
      <p>/</p>
      <a :href=HeaderLocationTwo.href>{{HeaderLocationTwo.name}}</a>
      <p>/</p>
      <p class="third">{{HeaderLocationThree.name}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PageHeader",
    data(){
      return{
        HeaderLocationOne:{},
        HeaderLocationTwo:{},
        HeaderLocationThree:{}
      }
    },
    computed:{

    },
    created() {
      this.HeaderLocationOne = this.common.HeaderLocationOne
      this.HeaderLocationTwo = this.common.HeaderLocationTwo
      this.HeaderLocationThree = this.common.HeaderLocationThree
    }
  }
</script>

<style scoped>
  #pageHeader{
    width: calc(100% - 200px - 20px);
    margin-left: 200px;
    background-color: #ffffff;
    padding-left: 20px;
    padding-top: 0;
    margin-top: -10px;
  }

  #location{
    margin-left: 4px;
    margin-right: 4px;
    font-size: 0.875rem;
  }

  #location p{
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    color: #818a91;
  }

  #location a:link{
    color: #56bde1;
    text-decoration:none;
  }

  #location a:visited{
    color: #56bde1;
    text-decoration:none;
  }

  #location a:hover{
    color: #167495;
    text-decoration: underline;
  }

  #font a:active{
    color: #56bde1;
    text-decoration:none;
  }

  #title h1{
    font-weight: 500;
  }

  #version{
    color: #818a91;
    font-size: 0.875rem;
    margin-top: -23px;
  }

  #line{
    background-color: rgba(165, 165, 165, 0.7);
    width: 100%;
    height: 1px;
    margin-left: -20px;
  }
</style>
